<!-- 图片链接列表：模块头+图片+标题+链接 -->
<template>
<div class="info-block">
  <router-link :to="'/hyzx/zhDetails/'+info.id"  class="info-block-a" target="_blank">
    <div class="div-1" v-bind:style="{backgroundImage:'url('+info.cover_img+')'}">
      <div class="div-1-1">{{info.title}}</div>
      <div class="div-1-2 data-ico">{{info.start_time}}</div>
      <div class="div-1-3 location-ico">{{info.place}}</div>
    </div>
  </router-link>
</div>
</template>
<script>
export default {
  name: 'HyzhImgInfo',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  box-sizing:border-box;
  height:280px;
  padding:0px;
  margin:0px 0px 10px 0px;
  //background-color:red;
  border:0px solid #ddd;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover > .div-1{
  border:1px solid var(--color6);
  box-shadow:0px 0px 1px 0px var(--color6);
}

.div-1{
  position:relative;
  height:280px;
  width:100%;
  padding:160px 0px 0px 0px;
  //background:var(--color6);
  color:#fff;
  border:1px solid #ddd;
  background-size: auto 160px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

.div-1-1{
  height:60px;
  padding:10px;
  font-size:14px;
  font-weight:600;
  text-align:left;
  color:#000;
}

.div-1-2{
  height:30px;
  padding:5px 10px 5px 25px;
  font-size:12px;
  color:#888888;
  text-align:left;
  line-height:15px;
  color:var(--color7);
  //background:yellow;
}

.div-1-3{
  height:30px;
  padding:5px 10px 5px 25px;
  font-size:12px;
  color:#888888;
  text-align:left;
  line-height:15px;
  color:var(--color7);
  //background:red;
}

.data-ico{
  background-image:url(./../../assets/clock.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 5px 3px;
}

.location-ico{
  background-image:url(./../../assets/location.png);
  background-size: 17px 17px;
  background-repeat: no-repeat;
  background-position: 5px 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/module/HyzhImgInfo.vue